import {
  Autocomplete as MuiAutoComplete,
  TextField,
  FormControl,
  FormLabel,
  Paper,
  Chip,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import { PALETTE } from "../../Theme/Palette";

const CustomPaper = (props) => {
  return <Paper elevation={8} {...props} sx={{ direction: "rtl", color: "#4C466F" }} />;
};

const AutoComplete = ({
  id,
  label,
  disabled,
  flex,
  labelFlex,
  placeholder,
  labelKey,
  idKey,
  data = [],
  value = [],
  onChange = () => {},
}) => {
  return (
    <FormControl
      disabled={disabled}
      sx={{
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
      }}
    >
      {label && (
        <FormLabel
          htmlFor={id}
          sx={{
            flex: labelFlex,
            textAlign: "right",
            color: "#4C466F !important",
            fontSize: "14px",
          }}
        >
          {label}
        </FormLabel>
      )}
      <MuiAutoComplete
        multiple
        disabled={disabled}
        id={id}
        clearIcon={false}
        options={data ?? []}
        value={value}
        isOptionEqualToValue={(option, value) => option[idKey] === value[idKey]}
        PaperComponent={CustomPaper}
        getOptionLabel={(option) => option[labelKey]}
        onChange={(event, options) => onChange(options)}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => {
            const { onDelete, ...otherTagProps } = getTagProps({ index });
            return (
              <Chip
                {...getTagProps({ index })}
                label={option[labelKey]}
                onDelete={disabled ? null : onDelete}
                deleteIcon={disabled ? null : <IoClose color={PALETTE.sixth} />}
                sx={{
                  backgroundColor: disabled ? "#EEEEEE" : "#dfdfdfff",
                  borderRadius: "0.4rem",
                  color: !disabled ? PALETTE.third : PALETTE.sixth,
                  fontSize: "0.9rem",
                  height: "auto",
                  margin: "0.1rem 0.2rem !important",
                  boxSizing: "border-box",
                  padding: "0.35rem 0.2rem",
                  "& span": {
                    whiteSpace: "pre-wrap ",
                  },
                  "& .MuiChip-deleteIcon": {
                    fontSize: "1.3rem",
                    marginRight: "-5px",
                    marginLeft: "5px",
                    width: 16,
                    minWidth: 16,
                    maxWidth: 16,
                  },
                  "&.Mui-disabled": {
                    opacity: 1,
                  },
                }}
              />
            );
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder={placeholder}
            sx={{
              color: "#4C466F",
              backgroundColor: "transparent",
              "& .MuiInputBase-root": {
                paddingRight: "0 !important",
                paddingLeft: "2rem !important",
                fontSize: "1rem",
                "&::before": {
                  content: "none",
                },
                "&::after": {
                  content: "none",
                },
                "& .MuiAutocomplete-endAdornment": {
                  direction: "rtl",
                  left: "0 !important",
                  right: "auto",
                  "& button": {},
                },
              },
            }}
          />
        )}
        sx={{
          flex: flex,
          direction: "rtl",
          minHeight: "40px",
          boxSizing: "border-box",
          color: disabled ? PALETTE.third : PALETTE.eightth,
          backgroundColor: !disabled ? PALETTE.primary : PALETTE.fifth,
          padding: "0.2rem",
          border: disabled ? "1px solid transparent" : `1px solid ${PALETTE.fourth}`,
          transition: "all 200ms linear",
          borderRadius: 2,
          "&:focus": {
            border: "1px solid #68618F",
          },
          "&:hover": {
            border: disabled ? "1px solid transparent" : `1px solid ${PALETTE.fourth}`,
          },
        }}
      />
    </FormControl>
  );
};

export default AutoComplete;
